import Vue from 'vue';
import state from '@/store/state';
import moment from 'moment';

// Trasnlate
Vue.filter('translate', key => state.translations[key] || key);

// Parse value and keep two decimals
Vue.filter('formatNumber', value => parseFloat(value).toFixed(2));

// Date format
Vue.filter('formatDate', (value) => {
  let val;
  if (value) {
    moment.locale(window.sevenConfig.company.language);
    const date = moment(value).format('ddd HH:mm');
    const day = state.translations[date.split(' ')[0].toLowerCase()] || date.split(' ')[0];
    val = `${day}  ${date.split(' ')[1]}`;
  } else {
    val = value;
  }
  return val;
});
